import { Description } from '@dgx-pr-spa/shared/util';
import { getPricegross, offersType } from '@shared/helpers/function.helpers';
import { OfferType } from '@dgx-pr-spa/shared/util';
import { Offers } from '@dgx-pr-spa/shared/util';
import { DataLayer } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { UpfrontPaymentSummary } from '@dgx-pr-spa/shared/util';
import { UntypedFormGroup } from '@angular/forms';
import {
  DeliveryErrors,
  DirectDebitErrors,
  FormStep,
} from '@dgx-pr-spa/shared/util';

export class GACompleteOrderCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly upfront: UpfrontPaymentSummary,
    public readonly deliveryDate
  ) {}

  get gaCommonData(): DataLayer {
    const offers = this.offers;
    const selected = this.selected;
    const currentItem = offers?.current_item;
    const customerType = 'G';
    const currentPlan = offers?.current_plan;
    const PRGroup = 'aws';
    const productName =
      currentItem?.make && currentItem?.appliance_category
        ? `${currentItem?.make} ${currentItem?.appliance_category}`
        : undefined;

    const upfront = this.upfront;

    const JobReferenceNumber = currentPlan?.reference_number
      ? currentPlan?.reference_number
      : 'Job Reference number not available';

    const installation = selected?.services
      ? getPricegross(selected.services, Description.Installation)
      : undefined;

    const disposal = selected?.services
      ? getPricegross(selected.services, Description.Disposal)
      : undefined;

    const delivery = selected?.services
      ? getPricegross(selected.services, Description.Delivery)
      : undefined;

    const dataLayer: DataLayer = {
      event: 'PRAWS',
      genericpagename: 'product-replacement-checkout',
      pagename: 'product-replacement-delivery',
      category: 'product-replacement',
      OfferType: offersType(offers)?.toString(),
      planNumber: currentPlan?.plan_number,
      productName,
      productModel: currentItem?.model,
      productNameOffer: `${selected?.make} ${selected?.appliance_category}`,
      productModelOffer: selected?.model,
      AccountBrand: currentItem?.make,
      Manufacturer: currentItem?.make,
      AccountBrandOffer: selected?.make,
      ManufacturerOffer: selected?.make,
      applianceName: currentItem?.appliance_category,
      upgrade: upfront?.upgradeFee,
      installation,
      disposal,
      delivery,
      totalCostReplacement: upfront?.replacementCost,
      outstandingMonthlyPayments: offers?.offer?.outstanding_dd_count,
      remainingPayment: offers?.offer?.outstanding_dd_amount,
      PRContinuedCover: upfront?.monthlyPayment,
      JobReferenceNumber,
      customerType,
      paymentOffer: 'MPM',
      installationTaken: upfront?.isInstallationAvailable
        ? upfront?.isInstallationSelected
          ? 'Yes'
          : 'No'
        : undefined,
      disposalTaken: upfront?.isDisposalAvailable
        ? upfront?.isDisposalSelected
          ? 'Yes'
          : 'No'
        : undefined,
      PRContinuedCoverTaken: upfront?.isProtectionSelected ? 'Yes' : 'No',
      deliveryDate: this.deliveryDate,
      PRGroup,
      rrp: selected?.rrp,
    };

    return dataLayer;
  }
}
export class GACompleteOrderDeliveryStep extends GACompleteOrderCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly upfront: UpfrontPaymentSummary,
    public readonly deliveryDate
  ) {
    super(offers, selected, upfront, deliveryDate);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      eventPR: 'product-replacement-delivery',
    };

    return dataLayer;
  }
}

export class GACompleteOrderDirectDebitStep extends GACompleteOrderCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly upfront: UpfrontPaymentSummary,
    public readonly deliveryDate
  ) {
    super(offers, selected, upfront, deliveryDate);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      eventPR: 'product-replacement-payment-plan',
      pagename: 'product-replacement-payment-plan',
    };

    return dataLayer;
  }
}

export class GACompleteOrderPaymentStep extends GACompleteOrderCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly upfront: UpfrontPaymentSummary,
    public readonly deliveryDate
  ) {
    super(offers, selected, upfront, deliveryDate);
  }

  get gaData(): DataLayer {
    const upgradeTaken =
      this.selected?.offer_type === OfferType.UPGRADE ? 'Yes' : 'No';

    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      eventPR: 'product-replacement-payment',
      pagename: 'product-replacement-payment',
      upgradeTaken,
    };
    return dataLayer;
  }
}

export class GACompleteOrderErrorsCommon {
  constructor(public readonly offers: Offers) {}

  get gaCommonErrorsData(): DataLayer {
    const offers = this.offers;
    const currentItem = offers?.current_item;
    const currentPlan = offers?.current_plan;
    const PRGroup = 'aws';
    const productName =
      currentItem?.make && currentItem?.appliance_category
        ? `${currentItem?.make} ${currentItem?.appliance_category}`
        : undefined;

    const dataLayer: DataLayer = {
      event: 'PRGenericEvent',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
      planNumber: currentPlan?.plan_number,
      productName,
      PRGroup,
    };
    return dataLayer;
  }
}

export class GACompleteOrderFormErrors extends GACompleteOrderErrorsCommon {
  constructor(
    public readonly offers: Offers,
    private readonly formStep: FormStep,
    private readonly form: UntypedFormGroup
  ) {
    super(offers);
  }

  get gaData(): DataLayer {
    const PRErrorMessage = (this.form?.get(this.formStep) as UntypedFormGroup)
      ?.controls
      ? this.getFormValidationErrors(
          (this.form?.get(this.formStep) as UntypedFormGroup)?.controls
        )
      : undefined;

    const PRevent =
      this.formStep === FormStep.Delivery
        ? 'PRFormErrorDelivery'
        : this.formStep === FormStep.DirectDebit
        ? 'PRFormErrorPayment'
        : undefined;

    const dataLayer: DataLayer = {
      ...this.gaCommonErrorsData,
      PRevent,
      PRErrorMessage,
    };

    return dataLayer;
  }

  getFormValidationErrors(stepControls) {
    const errorsArr = [];
    const errorEnum =
      this.formStep === FormStep.Delivery ? DeliveryErrors : DirectDebitErrors;

    if (stepControls) {
      Object.keys(stepControls).forEach((key) => {
        const capitalKey = key.replace(/^\w/, (char) => char.toUpperCase());
        if (
          stepControls[key] instanceof UntypedFormGroup &&
          stepControls[key].invalid
        ) {
          // TODO Catering for formgroup sortCode invalid status - review as per comments in
          errorsArr.push(`${errorEnum[`${capitalKey}Required`]}`);
        } else if (stepControls[key].errors) {
          if (stepControls[key]?.errors?.required) {
            errorsArr.push(`${errorEnum[`${capitalKey}Required`]}`);
          }
          if (stepControls[key]?.errors?.pattern) {
            errorsArr.push(`${errorEnum[`${capitalKey}Pattern`]}`);
          }
        }
      });
    }

    return errorsArr?.length > 1 ? errorsArr.join('|') : undefined;
  }
}
